<script>
export default {
    name: "StockSheet",

    data() {

        return {
            items:[], 
            store:{}
            
        };
    },

    mounted() {

        Promise.allSettled([  this.fetchStockSheet(),this.fetchStoreDetails(), ]).then(() => {
            window.print();
            window.onafterprint = () => window.close();
            window.oncancel = () => window.close();
        }).catch(() => {});
    },

    methods: {

        
        fetchStockSheet() {
            return this.$http.get(`Inventory/GetItemsStockLevelForStore?StoreId=${this.$route.params.storeId}`).then(response => {
                this.items = response.data;
            }).catch(() => {});
        },  fetchStoreDetails() {
            return this.$http.get(`masterData/SpecificStorageLocation?StoreId=${this.$route.params.storeId}`).then(response => {
                this.store = response.data;
            }).catch(() => {});
        },
         
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
          <div class="w-full flex flex-wrap max-h-8 overflow-auto border-b-2 border-t-2 border-gray-800" >
                              
                              
                              
                          </div>
       <h5 class="w-full font-bold text-center">STOCK SHEET</h5>
       <h5 class="w-full font-bold text-center">STORE: <span class="text-blue-700">{{ store[0].store }}</span></h5>
        <table class="table">
            <thead class="text-xs">
                <tr class="flex w-full">
                    <th class="p-tiny w-1/16">Code</th>
                                    <th class="p-tiny w-1/5">Item</th>
                                    <th class="p-tiny w-1/12">Quantity</th>
                                    <!-- <th class="p-tiny w-1/6">StockLevel</th> -->
                                    <!-- <th class="p-tiny w-1/6">CountUnits</th> -->
                                    <!-- <th class="p-tiny w-1/6">Variance</th> -->
                                    <th class="p-tiny w-1/6">Comment</th>
                </tr>
            </thead>
            <tbody class="text-xs flex flex-col">
                <tr class="w-full flex" v-for="(adStockTake, idx) in items" :key="idx">
                    <td class="p-tiny w-1/16">{{ adStockTake.itemID }}</td>
                                    <td class="p-tiny w-1/5">{{ adStockTake.itemName }}</td>
                                    <td class="p-tiny w-1/12"><input
                          type="text"
                          v-model.number="adStockTake.quantity"
                          class="input-control input-sm text-xs text-right"
                        /></td>
                                    <!-- <td class="p-tiny w-1/6">{{ adStockTake.PkSz }}</td> -->
                                    
                                    <!-- <td class="p-tiny w-1/6">{{ adStockTake.stockLevel }}</td> -->
                                    <!-- <td class="p-tiny w-1/6">{{ adStockTake.counttedQty }}</td> -->
                                    <!-- <td class="p-tiny w-1/6">{{adStockTake.counttedQty }}</td> -->
                                    <td class="p-tiny w-1/6"><input
                          type="text"
                          v-model.number="adStockTake.comment"
                          class="input-control input-sm text-xs text-right"
                        /></td>    
                </tr>
            </tbody>
        </table>
        <div class="w-full flex flex-wrap p-1 my-1 border-t-2 border-gray-800">
            
            <div class="w-full p-1 text-right">
                <h5 class="text-sm font-bold">Printed By: {{ $root.username }}</h5>
            </div>
        </div><div class="w-full text-right mt-35">  <tail-stamp v-if="printstamp"></tail-stamp>
       </div> 
    </div>
</template>